module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNCIgaGVpZ2h0PSIzMSIgdmlld0JveD0iMCAwIDE0IDMxIj4KICAgIDxwYXRoIGZpbGw9IiNGRkYiIGZpbGwtcnVsZT0ibm9uemVybyIgZD0iTTEzLjQzNiAxNS4xNTRIOS4yODR2MTUuMjEzSDIuOTkyVjE1LjE1NEgwVjkuODA4aDIuOTkydi0zLjQ2QzIuOTkyIDMuODc0IDQuMTY3IDAgOS4zNCAwTDE0IC4wMnY1LjE5aC0zLjM4MWMtLjU1NSAwLTEuMzM1LjI3Ni0xLjMzNSAxLjQ1NnYzLjE0N2g0LjcwMmwtLjU1IDUuMzQxeiIvPgo8L3N2Zz4K"


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/socials/facebook.svg
// module id = 6DHL
// module chunks = 0